import { FuzzySearch } from '@garmin/support-fuzzy-search';

export const getProductTagNameFromId = (state, getters) => (tagId) => {
  if (typeof tagId === 'undefined') {
    // eslint-disable-next-line no-param-reassign
    tagId = getters.getURLParam('topicTag');
  }

  if (tagId && getters.hasUserIdentifiedProduct) {
    const productTags = getters.product?.topics || [];

    if (productTags.length) {
      let productTagName = false;

      productTags.forEach((tag) => {
        if (tagId === tag.systemTagName) {
          productTagName = tag.displayTagName;
        }
      });

      return productTagName;
    }
    return false;
  }
  return false;
};

export const productListByTerm = (state) => (term) => {
  const termDecoded = FuzzySearch.searchifyString(term);

  return state.productList.filter((product) => {
    let matchedProductFlag = false;
    const currentProductName = product.searchName || '';
    const currentProductNameDecoded = FuzzySearch.searchifyString(currentProductName);
    const currentProductId = product.productId;

    if (
      currentProductName
      && currentProductId
      && (
        currentProductName.toLowerCase() === term
        || currentProductNameDecoded === termDecoded
        || FuzzySearch.isFuzzyMatch(currentProductName, term)
      )
    ) {
      matchedProductFlag = true;
    }

    return matchedProductFlag;
  });
};

export const productMatchByProductId = (state) => (identifierObject) => (state.productList || []).filter(
  (product) => {
    if (typeof identifierObject !== 'object' || !product) {
      return '';
    }

    return typeof (identifierObject || {}).partNumber !== 'undefined' && identifierObject.partNumber
      ? product.partNumber === identifierObject.partNumber
      : product.productId === (identifierObject || {}).productId && !product.partNumber;
  },
);

export const isProductContactOptionsDisabled = (state, getters) => getters.translations.scContactSections.disabledLegacyProducts.find((id) => {
  const { productID, identifier } = getters.urlParams;
  const compId = (decodeURIComponent(productID || '') || getters.product?.productId || decodeURIComponent(identifier || ''));
  return id.toLowerCase() === (compId || '').toLowerCase();
});
